/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { ItemVariantTypeResult } from '../../models/item-variant-type-result';

export interface ItemVariantTypesGet$Params {
  'Active-Tenant-Identifier': string;
}

export function itemVariantTypesGet(http: HttpClient, rootUrl: string, params: ItemVariantTypesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'itemVariants'?: Array<ItemVariantTypeResult>;
};
}>> {
  const rb = new RequestBuilder(rootUrl, itemVariantTypesGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      '_embedded'?: {
      'itemVariants'?: Array<ItemVariantTypeResult>;
      };
      }>;
    })
  );
}

itemVariantTypesGet.PATH = '/item-variant-types';
